<template>
    <Slide :title="title" :subtitle="subtitle">
        <div class="cr:md:mx-[7rem]">
            <div class="cr:grid cr:grid-cols-2 cr:md:grid-cols-4 cr:text-sm">
                <div v-for="producer in producers" class="cr:flex cr:items-center cr:gap-2 cr:p-1 cr:my-1">
                    <CustomCheckbox v-model="producer.selected" @update:modelValue="handleSelection($event, producer)"/>
                    <p>{{ producer.name }}</p>
                </div>
            </div>
        </div>
    </Slide>
</template>

<script setup lang="ts">
import Slide from "@/components/slides/Slide.vue";
import CustomCheckbox from "@/components/elements/CustomCheckbox.vue";
import {ref, computed} from "vue";
import {useErrorStore} from "@/stores/error.ts";

const producers = ref([
    {name: '0', selected: false},
    {name: '1-2', selected: false},
    {name: '3-5', selected: false},
    {name: '6+', selected: false},
]);

const errorStore = useErrorStore();

const props = defineProps({
    title: {
        type: String,
        default: 'How many producers do you have?'
    },
    subtitle: {
        type: String,
        default: ''
    }
});

const handleSelection = (event: any, producer: any) => {
    producers.value.forEach(p => p.selected = false);
    
    if (event) {
        producer.selected = true;
    }
}

const slidePayload = computed(() => {
    return {
        number_producers: producers.value.find(p => p.selected)?.name,
    }
});
const validate = () => {
    if (!producers.value.find(p => p.selected)) {
        errorStore.report('Please select one.')
        return false;
    }

    return true;
}
const canContinue = computed(() => true);

defineExpose({
    canContinue,
    slidePayload,
    validate
});
</script>